import LFCSelectFormJudge from '_components-with-data/inputs/LFCSelectFormJudge';
import LFCAutocomplete, {
  ChangeParameter,
  multiSelectData
} from '_components/inputs/LFCAutocomplete';
import LFCButton from '_components/inputs/LFCButton';
import LFCDatetimePicker from '_components/inputs/LFCDatetimePicker';
import LFCFormRowGroup from '_components/layout/LFCFormRowGroup';
import ProgressBar from '_components/ProgressBar';
import {getLFCData, handleInputChange2} from '_logics/LFCUtil';
import axios, {CancelTokenSource} from 'axios';
import dayjs from 'dayjs';
import {useSnackbar} from 'notistack';
import {useCallback, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {SearchTypeRadioBtn} from './components/SearchTypeRadioBtn';
import {SearchConditions, SearchType} from './types';

interface SearchPanelProps {
  onSearch: (searchConditions: SearchConditions) => void;
}

export const SearchPanel = (props: SearchPanelProps) => {
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const [startProcess, setStartProcess] = useState<boolean>(false);
  const cancelSource = useRef<CancelTokenSource | null>(null);
  const [isAutoCompleteReset, setIsAutoCompleteReset] = useState<boolean>(false);
  const [workList, setWorkList] = useState<{label: string}[]>([]);
  const [deviceidList, setDeviceidList] = useState<{label: string}[]>([]);

  //入力中条件
  const [searchConditions, setSearchConditions] = useState<SearchConditions>({
    selectDateFrom: dayjs().add(-7, 'd').format('YYYY-MM-DD HH:mm:ss'),
    selectDateTo: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    work: [],
    deviceid: [],
    judge: 9,
    searchType: SearchType.DAY
  });

  /**
   * 入力値変更
   */
  const handleChange = useCallback((event: any) => {
    setSearchConditions(prev => ({...prev, [event.target.name]: event.target.value}));
  }, []);

  /**
   * 入力値変更
   */
  const autoOnChange = useCallback((relayDatas: ChangeParameter) => {
    setSearchConditions(prev => ({...prev, [relayDatas.name]: relayDatas.data}));
  }, []);

  /**
   * 検索処理
   */
  const handleSearch = useCallback(() => {
    props.onSearch(searchConditions);
  }, [searchConditions]);

  /**
   * リセット処理
   */
  const handleReset = useCallback(() => {
    setSearchConditions({
      selectDateFrom: dayjs().add(-7, 'd').format('YYYY-MM-DD HH:mm:ss'),
      selectDateTo: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      work: [],
      deviceid: [],
      judge: 9,
      searchType: SearchType.DAY
    });
  }, []);

  /**
   * 初期処理
   */
  useEffect(() => {
    setStartProcess(true);

    cancelSource.current = axios.CancelToken.source();
    Promise.allSettled([
      //機種
      getLFCData({
        snack: enqueueSnackbar,
        sql_id: 42009,
        parameters: {},
        t,
        cancelToken: cancelSource.current.token
      }).then(ds => {
        const tmp: {label: string}[] = ds.map((item: {work: string}) => {
          return {label: item['work']};
        });
        setWorkList(tmp);
      }),
      //検査装置
      getLFCData({
        snack: enqueueSnackbar,
        sql_id: 42010,
        parameters: {},
        t,
        cancelToken: cancelSource.current.token
      }).then(ds => {
        const tmp: {label: string}[] = ds.map((item: {deviceid: string}) => {
          return {label: item['deviceid']};
        });
        setDeviceidList(tmp);
      })
    ]).finally(() => {
      setStartProcess(false);
    });

    return () => {
      // アンマウント処理
      if (cancelSource.current) cancelSource.current.cancel('req cancel');
    };
  }, []);

  return (
    <>
      <ProgressBar startProcess={startProcess} screenLock />
      <LFCFormRowGroup>
        <LFCDatetimePicker
          name={'selectDateFrom'}
          label={t('対象期間From')}
          value={searchConditions.selectDateFrom}
          required
          onChange={handleChange}
        />
        <LFCDatetimePicker
          name={'selectDateTo'}
          label={t('対象期間To')}
          value={searchConditions.selectDateTo}
          required
          onChange={handleChange}
        />
        <LFCAutocomplete
          name={'work'}
          label={t('機種')}
          id={'work'}
          value={multiSelectData(workList, searchConditions.work)}
          onChange={autoOnChange}
          onReset={isAutoCompleteReset}
          doneReset={setIsAutoCompleteReset}
          multiple={true}
          selectItem={workList}
        />
        <LFCAutocomplete
          name={'deviceid'}
          label={t('検査装置')}
          id={'deviceid'}
          value={multiSelectData(deviceidList, searchConditions.deviceid)}
          onChange={autoOnChange}
          multiple={true}
          onReset={isAutoCompleteReset}
          doneReset={setIsAutoCompleteReset}
          selectItem={deviceidList}
        />
        <LFCSelectFormJudge
          name={'judge'}
          value={searchConditions.judge}
          onChange={event => handleInputChange2(event, searchConditions, setSearchConditions)}
        />
      </LFCFormRowGroup>
      <LFCFormRowGroup>
        <SearchTypeRadioBtn
          value={searchConditions.searchType}
          onChange={(val: number) => {
            setSearchConditions({...searchConditions, searchType: val});
          }}
        />

        <LFCButton color="primary" onClick={handleSearch}>
          {t('検索')}
        </LFCButton>
        <LFCButton onClick={handleReset}>{t('リセット')}</LFCButton>
      </LFCFormRowGroup>
    </>
  );
};
